import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTextField } from './TextField.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTextField({ prefix }));
}
